import React from 'react';

import type { TopTagResponse } from '@schibsted/frapi-schema';

import { console } from '../../../../core/system/console/index.js';
import { usePulseContext } from '../../../../core/mandatory-integrations/pulse/PulseProvider.js';

interface FilterToggleProps {
  sectionId: string;
  hasActiveFilters: boolean;
  setFilters: (filters: TopTagResponse) => void;
  setOpenFilter: (isOpen: boolean) => void;
}

export const FilterToggle: React.FC<FilterToggleProps> = ({
  sectionId,
  hasActiveFilters,
  setFilters,
  setOpenFilter,
}) => {
  const { trackClickUIElement } = usePulseContext();

  const handleClick = (event: React.MouseEvent): void => {
    event.preventDefault();
    trackClickUIElement({
      object: {
        id: 'filter:open-filters',
        elementType: 'Button',
        name: `${hasActiveFilters ? 'edit' : 'open'} filters`,
        custom: {
          sectionId,
        },
      },
    }).finally(() => fetchFilters());
  };

  const fetchFilters = async () => {
    try {
      if (sectionId) {
        const raw = await fetch(
          `/api/top-tags?sectionIds=${sectionId}&tagTypes=machine&phrase=vink&limit=100`,
        );
        const result = await raw.json();
        setFilters(result);
        setOpenFilter(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <button className="open-filters" onClick={handleClick}>
      {hasActiveFilters ? 'Endre filter' : 'Åpne filter'}
    </button>
  );
};
